import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

export function useRefuseQuoteService(contractId: string) {
  return useMutation<void, Error, string>({
    mutationFn: (reason) =>
      axiosInstance()
        .post(`/folloportal/contracts/${contractId}/refuse`, { meta: { reason: reason || null } })
        .then((r) => r.data),
  });
}
